(function($) {

  // Dreamlab Back to Top button
  if ($('#dl-back-to-top').length) {
    var btn = $('#dl-back-to-top');
    var scrollTrigger = btn.data('threshold'), // Scroll threshold in pixels
      backToTop = function() {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > scrollTrigger) {
          // Show button
          $('#dl-back-to-top').addClass('is-shown');
          $('#dl-back-to-top').removeClass('is-hidden');
        } else {
          // Hide button
          $('#dl-back-to-top').removeClass('is-shown');
          $('#dl-back-to-top').addClass('is-hidden');
        }
      };
    backToTop();
    $(window).on('scroll', function() {
      backToTop();
    });
    $('#dl-back-to-top').on('click', function(e) {
      e.preventDefault();
      $('html,body').animate({
        scrollTop: 0
      }, btn.data('duration')); // Back To Top Animation duration in milliseconds
    });
  }

})(jQuery);
